import { Card, Grid, SegmentedControl, Text } from '@mantine/core';
import DatePickerControl from '../DatePicker';
import SegmentSelector from '../Segments/SegmentSelector';

const AudienceRecommenderForm = ({ recommender, setRecommender, scope }) => {
  return (
    <Card data-tour="segmentField" withBorder>
      <Card.Section inheritPadding py="sm">
        <SegmentSelector
          title="Behavioral Segment"
          description="This determines who will see your product block based on aggregated user behavior. Behavioral segments are evaluated continuously and are not real-time."
          segmentId={recommender.segmentId}
          onSelect={(segment) => setRecommender({ ...recommender, segmentId: segment?.id })}
          campaignScope={scope}
          scope="behavior"
          forType="recommender"
          sizeTitle={3}
          sizeBody={9}
        />
        <Grid data-tour="bannerSegmentRelationship">
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <Text fw={500}>Action</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 9 }}>
            <SegmentedControl
              value={String(recommender.inverseSegmentSelection)}
              onChange={(value) => setRecommender({ ...recommender, inverseSegmentSelection: value === 'true' })}
              data={[
                { label: 'Include', value: 'false' },
                { label: 'Exclude', value: 'true' },
              ]}
            />
            <Text size="sm" c="dimmed">
              This controls whether the Product Block is shown or hidden for members of the chosen segment.
            </Text>
          </Grid.Col>
        </Grid>
        <hr />
        <Grid>
          <Grid.Col span={{ base: 12, sm: 3 }}></Grid.Col>
          <Grid.Col span={{ base: 12, sm: 9 }}>
            <SegmentedControl
              value={recommender.segmentRelationship ?? ''}
              onChange={(segmentRelationship) => setRecommender({ ...recommender, segmentRelationship })}
              data={[
                { label: 'And', value: 'and' },
                { label: 'Or', value: 'or' },
              ]}
            />
          </Grid.Col>
        </Grid>
        <hr />
        <SegmentSelector
          title="Profile filter"
          description="This determines who will see your product block based on their current attributes. This filter applied in real-time."
          segmentId={recommender.realtimeSegmentId}
          onSelect={(segment) => setRecommender({ ...recommender, realtimeSegmentId: segment?.id || null })}
          campaignScope="marketing"
          scope="profileFilter"
          forType="recommender"
          optional={true}
          sizeTitle={3}
          sizeBody={9}
        />
        <hr />
        <Grid mb="md" mt="md">
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <Text fw={500}>Show when</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 9 }}>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DatePickerControl
                  prepend="from"
                  size="sm"
                  showTimeSelect
                  placeholder="Any date"
                  value={recommender.startTime}
                  onChange={(value) => setRecommender({ ...recommender, startTime: value })}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DatePickerControl
                  prepend="to"
                  append="local time"
                  size="sm"
                  showTimeSelect
                  placeholder="Any date"
                  value={recommender.endTime}
                  onChange={(value) => setRecommender({ ...recommender, endTime: value })}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default AudienceRecommenderForm;
